import RequestService from '../../../../services/request-service';

/**
 * Player Odds Request (also known as Goal Scorers)
 */
export class MatchDetailsPrematchPlayerOddsRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.playerOdds;
    this.method = 'get';
    this.getParams = {
      MatchID: null,
    };
    this.headers = null;
  }
}
